import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Optional, Output } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { FinancialInstitution, LoaderState } from '@store/core/core.interface';
import { FiSelectionComponent } from '@core/components/fi-selection/fi-selection.component';
import { AsyncPipe } from '@angular/common';

export interface LinkBankSheetData {
  financialInstitutions: LoaderState<FinancialInstitution[]>;
  linkedFIIds: string[];
  userProfileRef?: string;
}

@Component({
  selector: 'pbb-link-bank-sheet',
  template: `
    <div class="link-bank-sheet-container" [class.modal-variant]="isDialog">
      @if (isDialog) {
      <div mat-dialog-title class="flex-end">
        <button
          mat-icon-button
          mat-dialog-close
          class="close-btn"
          [title]="'COMMON.BUTTON.DIALOG.CLOSE' | translate"
          [attr.aria-label]="'COMMON.BUTTON.DIALOG.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
      }

      <div class="link-bank-sheet-header">
        <h2>{{ 'COMMON.LINK_MORE_WAYS_TO_PAY' | translate }}</h2>
      </div>

      <pbb-fi-selection
        id="link-bank-sheet_fi-list"
        (fiSelected)="onFiSelected($event)"
        [financialInstitutions]="data.financialInstitutions"
        [linkedFIIds]="data.linkedFIIds"
      ></pbb-fi-selection>
    </div>
  `,
  styleUrls: ['./link-bank-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FiSelectionComponent, TranslateModule, MatIconModule, MatButtonModule, MatDialogModule],
})
export class LinkBankSheetComponent {
  data: LinkBankSheetData;
  isDialog: boolean;

  constructor(
    @Optional() private bottomSheetRef?: MatBottomSheetRef<LinkBankSheetComponent>,
    @Optional() private dialogRef?: MatDialogRef<LinkBankSheetComponent>,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) private bottomSheetData?: LinkBankSheetData,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData?: LinkBankSheetData
  ) {
    // Use either dialog or bottom sheet data
    this.data = this.dialogData ||
      this.bottomSheetData || {
        financialInstitutions: { data: [], isLoading: false },
        linkedFIIds: [],
      };

    // Check if opened as dialog (desktop) or bottom sheet (mobile)
    this.isDialog = !!this.dialogRef;
  }

  onFiSelected(selectedFI: FinancialInstitution): void {
    if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss(selectedFI);
    } else if (this.dialogRef) {
      this.dialogRef.close(selectedFI);
    }
  }
}
